(function () {
  var initializedAttribute = 'data-product-card-slider-initialized';
  var mobileAttribute = 'data-product-card-slider-mobile';

  function isMobileCardMedia() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function getImages(slider) {
    return Array.prototype.slice.call(slider.querySelectorAll('img'));
  }

  function clearInlineImageState(slider) {
    getImages(slider).forEach(function (image) {
      image.style.opacity = '';
      image.classList.remove('active');
    });
    delete slider.dataset.currentSlide;
  }

  function setSlide(slider, index) {
    var images = getImages(slider);
    if (!images.length) return;

    var safeIndex = Math.max(0, Math.min(index, images.length - 1));

    images.forEach(function (image, imageIndex) {
      image.style.opacity = imageIndex === safeIndex ? '1' : '0';
      image.classList.toggle('active', imageIndex === safeIndex);
    });

    slider.dataset.currentSlide = String(safeIndex + 1);
  }

  function stepSlide(slider, direction) {
    var images = getImages(slider);
    if (images.length < 2) return;

    var current = Number(slider.dataset.currentSlide || 1) - 1;
    var next = (current + direction + images.length) % images.length;
    setSlide(slider, next);
  }

  function initMobileSlider(slider) {
    clearInlineImageState(slider);
    slider.setAttribute(mobileAttribute, 'true');
    slider.removeAttribute(initializedAttribute);
  }

  function initDesktopSlider(slider) {
    if (!slider || slider.hasAttribute(initializedAttribute)) return;

    var images = getImages(slider);
    if (!images.length) return;

    slider.setAttribute(initializedAttribute, 'true');
    slider.removeAttribute(mobileAttribute);
    slider.dataset.slides = String(images.length);
    setSlide(slider, 0);

    var previousButton = slider.querySelector('.slider_left');
    var nextButton = slider.querySelector('.slider_right');

    if (previousButton && !previousButton.dataset.productCardSliderBound) {
      previousButton.dataset.productCardSliderBound = 'true';
      previousButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        stepSlide(slider, -1);
      });
    }

    if (nextButton && !nextButton.dataset.productCardSliderBound) {
      nextButton.dataset.productCardSliderBound = 'true';
      nextButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        stepSlide(slider, 1);
      });
    }

    if (!slider.dataset.productCardSliderHoverBound) {
      slider.dataset.productCardSliderHoverBound = 'true';
      slider.addEventListener('pointerenter', function (event) {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        if (isMobileCardMedia()) return;
        if (getImages(slider).length > 1) setSlide(slider, 1);
      });

      slider.addEventListener('pointerleave', function (event) {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        if (isMobileCardMedia()) return;
        setSlide(slider, 0);
      });
    }
  }

  function initSlider(slider) {
    if (!slider) return;

    if (isMobileCardMedia()) {
      initMobileSlider(slider);
      return;
    }

    initDesktopSlider(slider);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.card-product__slider').forEach(initSlider);
  }

  var resizeTimer;
  function refreshAll() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      initAll(document);
    }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  window.addEventListener('resize', refreshAll);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.card-product__slider')) {
          initSlider(node);
          return;
        }
        if (node.querySelectorAll) initAll(node);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
